import { debounce } from "../application";

document.addEventListener("turbo:load", function () {
    initializeProductSearchBars(document);
});

document.addEventListener("turbo:frame-load", function () {
    initializeProductSearchBars(document);
});

function initializeProductSearchBars(element) {
    const mobileSearchModalInputs = Array.from(element.getElementsByClassName('mobile-modal-search-input'));

    mobileSearchModalInputs.forEach(mobileSearchModalInput => {
        initMobileProductSearchBar(mobileSearchModalInput);
    });
}

// Store debounced handlers for each input element. 
// Ensures we don't add multiple listeners to the same input element
const inputHandlers = new WeakMap();

function initMobileProductSearchBar(textInput) {
    if (!textInput) return;

    // Remove existing handler if it exists
    const existingHandler = inputHandlers.get(textInput);
    if (existingHandler) {
        textInput.removeEventListener("input", existingHandler);
    }

    // Create debounced handler
    const handler = debounce(function () {
        handleMobileSearchInput(textInput);
    }, 200);

    // Store the handler
    inputHandlers.set(textInput, handler);

    // Add the listener
    textInput.addEventListener("input", handler);
}

function handleMobileSearchInput(textInput) {
    if (textInput.value.length < 2) {
        return;
    }

    let form = textInput.closest('form');

    if (form.dataset.turboFrame === 'search_results') {
        const searchTerm = textInput.value;
        const url = `/search?search[term]=${encodeURIComponent(searchTerm)}`;

        const frame = document.getElementById('search_results');
        if (frame) {
            frame.src = url;
        }
    } else {
        form.requestSubmit();
    }
}
